import type { MulticolorValue } from '@elfsight/configurator-contracts';
import type { ButtonProps } from './Button';

export type WidgetButtonSettings = Pick<
  ButtonProps,
  | 'text'
  | 'mode'
  | 'font'
  | 'borderRadius'
  | 'horizontalPadding'
  | 'verticalPadding'
  | 'fullWidth'
  | 'color'
  | 'fontColor'
> & {
  size?: number | 'custom';
  iconColor?: MulticolorValue;
};

export const widgetButtonDefaults = {
  text: 'Button',
  mode: 'contain',
  color: '#197bff',
  fontColor: '#ffffff',
  font: {
    fontSize: 13,
    fontWeight: 'bold'
  },
  borderRadius: 4,
  horizontalPadding: 20,
  verticalPadding: 9,
  fullWidth: false,

  size: 13
} as const;

const loadMoreButtonBaseDefaults: WidgetButtonSettings = {
  text: 'Load More',
  mode: 'contain',
  font: {
    fontSize: 13,
    fontWeight: 'bold'
  },
  borderRadius: 4,
  horizontalPadding: 52,
  verticalPadding: 9,
  fullWidth: false,

  size: 13
};

export const loadMoreButtonLightThemeDefaults: WidgetButtonSettings = {
  ...loadMoreButtonBaseDefaults,
  color: 'rgba(17, 17, 17, 0.05)',
  fontColor: 'rgb(17, 17, 17)'
};

export const loadMoreButtonDarkThemeDefaults: WidgetButtonSettings = {
  ...loadMoreButtonBaseDefaults,
  color: 'rgba(255, 255, 255, 0.05)',
  fontColor: 'rgb(255, 255, 255)'
};

export const loadMoreButtonDefaults = loadMoreButtonLightThemeDefaults;
